import React, { Component } from "react"
import { Row, Col, Card, CardBody, Button, CardHeader, CardTitle, Badge, Alert } from "reactstrap"
import MetaTags from 'react-meta-tags'
import moment from 'moment'
import Select from 'react-select'
import SweetAlert from 'react-bootstrap-sweetalert'

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import "./datatables.scss"

import httprequester from '../../lib/httprequester'

class HandlingCMS extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Group content by type with their limits
      contentGroups: {
        article: { items: [], maxLimit: 4, label: 'Artikel Ilmiah' },
        event: { items: [], maxLimit: 3, label: 'Acara Ilmiah Nasional' },
        'event-internasional': { items: [], maxLimit: 3, label: 'Acara Internasional' },
        'event-homepage': { items: [], maxLimit: 3, label: 'Acara Homepage' },
        jurnal: { items: [], maxLimit: 3, label: 'Jurnal' },
        'tata laksana': { items: [], maxLimit: 3, label: 'Pedoman Tata Laksana' },
        cme: { items: [], maxLimit: 3, label: 'CME Online' },
        webinar: { items: [], maxLimit: 3, label: 'Webcast' },
        animasi: { items: [], maxLimit: 3, label: 'Petunjuk Pemakaian Obat' },
        tindakan: { items: [], maxLimit: 3, label: 'Tindakan Medis Spesialistik' },
        'tanya-ahli': { items: [], maxLimit: 3, label: 'Tanya Ahli' }
      },
      alert: false,
      message: '',
      loading: false,
      searchLoading: {},
      searchOptions: {}
    }

    // Debounce timers for search
    this.searchTimeouts = {}
  }

  getHomepage = () => {
    let body = {}
    httprequester.postnobody('homepage/getall_detail', body, {
      success: async function (response) {
        if (response.data.message == "success") {
          // Group the data by content type
          const groupedData = {}
          Object.keys(this.state.contentGroups).forEach(type => {
            groupedData[type] = { ...this.state.contentGroups[type], items: [] }
          })

          response.data.detailMessage.forEach(item => {
            if (groupedData[item.hp_type]) {
              groupedData[item.hp_type].items.push({
                hp_id: item.hp_id,
                hp_hid: item.hp_hid,
                hp_title: item.hp_title,
                hp_penulis: item.hp_penulis,
                hp_thumbnail: item.hp_thumbnail,
                hp_date: item.hp_date,
                hp_date_end: item.hp_date_end,
                hp_summary: item.hp_summary,
                hp_kuota: item.hp_kuota,
                hp_kuota_left: item.hp_kuota_left
              })
            }
          })

          this.setState({
            contentGroups: groupedData
          })
        }
      }.bind(this),
      error: function (err) {
        console.error(err)
      }.bind(this)
    })
  }

  searchContent = (type, searchTerm) => {
    // Clear previous timeout
    if (this.searchTimeouts[type]) {
      clearTimeout(this.searchTimeouts[type])
    }

    if (!searchTerm || searchTerm.length < 2) {
      this.setState(prevState => ({
        searchOptions: { ...prevState.searchOptions, [type]: [] }
      }))
      return
    }

    // Debounce search requests
    this.searchTimeouts[type] = setTimeout(() => {
      this.performSearch(type, searchTerm)
    }, 300) // 300ms delay
  }

  performSearch = (type, searchTerm) => {
    console.log('Performing search for:', type, 'with term:', searchTerm)

    this.setState(prevState => ({
      searchLoading: { ...prevState.searchLoading, [type]: true }
    }))

    const body = {
      type: type,
      search: searchTerm,
      page: 1,
      limit: 20
    }

    console.log('Search request body:', body)

    httprequester.postnobody('homepage/search_content', body, {
      success: function (response) {
        console.log('Search response:', response)
        if (response.data && response.data.message === "success") {
          // Filter out duplicates and ensure unique IDs
          const uniqueItems = response.data.detailMessage.filter((item, index, self) =>
            index === self.findIndex(t => t.id === item.id)
          )

          console.log('Original items count:', response.data.detailMessage.length)
          console.log('Unique items count:', uniqueItems.length)

          const options = uniqueItems.map(item => ({
            value: item.id,
            label: item.title,
            author: item.author,
            thumbnail: item.thumbnail,
            date: item.date,
            summary: item.summary
          }))

          console.log('Search options created:', options)

          this.setState(prevState => ({
            searchOptions: { ...prevState.searchOptions, [type]: options },
            searchLoading: { ...prevState.searchLoading, [type]: false }
          }))
        } else {
          console.log('Search failed:', response.data ? response.data.message : 'No response data')
          this.setState(prevState => ({
            searchOptions: { ...prevState.searchOptions, [type]: [] },
            searchLoading: { ...prevState.searchLoading, [type]: false }
          }))
        }
      }.bind(this),
      error: function (err) {
        console.error('Search error:', err)
        this.setState(prevState => ({
          searchOptions: { ...prevState.searchOptions, [type]: [] },
          searchLoading: { ...prevState.searchLoading, [type]: false }
        }))
      }.bind(this)
    })
  }

  addContent = (type, selectedOption) => {
    const currentGroup = this.state.contentGroups[type]

    if (currentGroup.items.length >= currentGroup.maxLimit) {
      this.setState({
        message: `Maksimal ${currentGroup.maxLimit} item untuk ${currentGroup.label}`,
        alert: true
      })
      return
    }

    // Check if item already exists in this group
    const exists = currentGroup.items.some(item => item.hp_hid === selectedOption.value)
    if (exists) {
      this.setState({
        message: 'Item sudah dipilih sebelumnya',
        alert: true
      })
      return
    }

    // Check if item exists in any other group
    const existsInOtherGroup = Object.keys(this.state.contentGroups).some(otherType => {
      if (otherType === type) return false
      return this.state.contentGroups[otherType].items.some(item => item.hp_hid === selectedOption.value)
    })

    if (existsInOtherGroup) {
      this.setState({
        message: 'Item ini sudah dipilih di kategori lain',
        alert: true
      })
      return
    }

    const newItem = {
      hp_hid: selectedOption.value,
      hp_title: selectedOption.label,
      hp_penulis: selectedOption.author,
      hp_thumbnail: selectedOption.thumbnail,
      hp_date: selectedOption.date,
      hp_date_end: selectedOption.date_end || null,
      hp_summary: selectedOption.summary,
      hp_kuota: selectedOption.kuota || null,
      hp_kuota_left: selectedOption.kuota_left || null
    }

    this.setState(prevState => ({
      contentGroups: {
        ...prevState.contentGroups,
        [type]: {
          ...prevState.contentGroups[type],
          items: [...prevState.contentGroups[type].items, newItem]
        }
      }
    }))
  }

  removeContent = (type, hp_hid) => {
    this.setState(prevState => ({
      contentGroups: {
        ...prevState.contentGroups,
        [type]: {
          ...prevState.contentGroups[type],
          items: prevState.contentGroups[type].items.filter(item => item.hp_hid !== hp_hid)
        }
      }
    }))
  }

  saveAllChanges = async () => {
    this.setState({ loading: true })

    try {
      // Prepare the complete content groups data
      const body = {
        contentGroups: this.state.contentGroups
      }

      // Use the new bulk update endpoint
      httprequester.postnobody('homepage/bulk_update', body, {
        success: async function (response) {
          if (response.data.message === "success") {
            this.setState({
              message: 'Semua perubahan berhasil disimpan',
              alert: true,
              loading: false
            })

            // Refresh data
            await this.getHomepage()
          } else {
            this.setState({
              message: 'Terjadi kesalahan saat menyimpan',
              alert: true,
              loading: false
            })
          }
        }.bind(this),
        error: function (err) {
          console.error(err)
          this.setState({
            message: 'Terjadi kesalahan saat menyimpan',
            alert: true,
            loading: false
          })
        }.bind(this)
      })

    } catch (error) {
      console.error(error)
      this.setState({
        message: 'Terjadi kesalahan saat menyimpan',
        alert: true,
        loading: false
      })
    }
  }

  handlecancel = () => {
    this.setState({
      alert: false
    })
  }

  componentDidMount() {
    this.getHomepage()
  }

  componentWillUnmount() {
    // Clear all search timeouts
    Object.values(this.searchTimeouts).forEach(timeout => {
      if (timeout) clearTimeout(timeout)
    })
  }

  render() {
    const { contentGroups, loading, searchLoading, searchOptions } = this.state

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Headline | Ruang Ilmiah</title>
          </MetaTags>
          <div className="container-fluid">
            <Breadcrumbs title="Headline" breadcrumbItem="Headline" />

            <Row className="mb-3">
              <Col className="col-12">
                <Alert color="info">
                  <strong>Petunjuk:</strong> Pilih konten yang akan ditampilkan sebagai headline di halaman depan.
                  Artikel maksimal 4 item, konten lainnya maksimal 3 item.
                </Alert>
              </Col>
            </Row>

            <Row>
              <Col className="col-12">
                <div className="headline-content-groups">
                  {Object.keys(contentGroups).map(type => {
                    const group = contentGroups[type]
                    const isAtLimit = group.items.length >= group.maxLimit
                    const progressPercentage = (group.items.length / group.maxLimit) * 100

                    return (
                      <Card key={type} className="mb-4">
                        <CardHeader>
                          <CardTitle className="d-flex justify-content-between align-items-center">
                            <span>{group.label}</span>
                            <div className="d-flex align-items-center">
                              <Badge
                                color={isAtLimit ? "success" : "primary"}
                                className="me-2"
                              >
                                {group.items.length}/{group.maxLimit}
                              </Badge>
                              <div className="progress" style={{ width: '100px', height: '8px' }}>
                                <div
                                  className={`progress-bar ${isAtLimit ? 'bg-success' : 'bg-primary'}`}
                                  style={{ width: `${progressPercentage}%` }}
                                ></div>
                              </div>
                            </div>
                          </CardTitle>
                        </CardHeader>
                        <CardBody>
                          {/* Selected Items */}
                          <div className="selected-items mb-3">
                            {group.items.length > 0 ? (
                              <div className="row">
                                {group.items.map((item, index) => (
                                  <div key={`${type}-${item.hp_hid}-${index}`} className="col-md-6 col-lg-4 mb-3">
                                    <div className="selected-item-card">
                                      <div className="d-flex">
                                        <div className="item-thumbnail me-3">
                                          <img
                                            src={item.hp_thumbnail}
                                            alt={item.hp_title}
                                            className="img-thumbnail"
                                            style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                          />
                                        </div>
                                        <div className="item-content flex-grow-1">
                                          <h6 className="mb-1" title={item.hp_title}>
                                            {item.hp_title}
                                          </h6>
                                          <small className="text-muted d-block">
                                            {item.hp_penulis}
                                          </small>
                                          <small className="text-muted">
                                            {moment(item.hp_date).format('DD MMM YYYY')}
                                          </small>
                                        </div>
                                        <div className="item-actions">
                                          <Button
                                            color="danger"
                                            size="sm"
                                            onClick={() => this.removeContent(type, item.hp_hid)}
                                            className="btn-icon"
                                          >
                                            <i className="bx bx-x"></i>
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center text-muted py-3">
                                <i className="bx bx-image-alt display-4"></i>
                                <p className="mt-2">Belum ada konten yang dipilih</p>
                              </div>
                            )}
                          </div>

                          {/* Add Content Dropdown */}
                          <div className="add-content-section">
                            <Select
                              placeholder={`Cari ${group.label.toLowerCase()}...`}
                              options={searchOptions[type] || []}
                              value={null}
                              isLoading={searchLoading[type] || false}
                              onInputChange={(inputValue) => {
                                console.log('Search input changed:', inputValue, 'for type:', type)
                                this.searchContent(type, inputValue)
                              }}
                              onChange={(selectedOption) => {
                                console.log('Option selected:', selectedOption)
                                if (selectedOption) {
                                  this.addContent(type, selectedOption)
                                }
                              }}
                              isDisabled={isAtLimit}
                              noOptionsMessage={() => "Ketik minimal 2 karakter untuk mencari..."}
                              formatOptionLabel={(option) => (
                                <div className="d-flex align-items-center">
                                  <img
                                    src={option.thumbnail}
                                    alt={option.label}
                                    style={{ width: '40px', height: '40px', objectFit: 'cover', marginRight: '10px' }}
                                    className="rounded"
                                    onError={(e) => {
                                      e.target.src = '/images/default-thumbnail.jpg'
                                    }}
                                  />
                                  <div>
                                    <div className="fw-medium">{option.label}</div>
                                    <small className="text-muted">{option.author}</small>
                                  </div>
                                </div>
                              )}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              isClearable={true}
                              isSearchable={true}
                            />
                            {isAtLimit && (
                              <small className="text-warning d-block mt-1">
                                <i className="bx bx-info-circle me-1"></i>
                                Maksimal {group.maxLimit} item telah tercapai
                              </small>
                            )}
                          </div>
                        </CardBody>
                      </Card>
                    )
                  })}
                </div>
              </Col>
            </Row>

            {/* Save Button */}
            <Row>
              <Col className="col-12">
                <div className="text-center">
                  <Button
                    color="success"
                    size="lg"
                    onClick={this.saveAllChanges}
                    disabled={loading}
                    className="px-5"
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Menyimpan...
                      </>
                    ) : (
                      <>
                        <i className="bx bx-save me-2"></i>
                        Simpan Semua Perubahan
                      </>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          {this.state.alert ? (
            <SweetAlert
              success
              title={this.state.message}
              onConfirm={this.handlecancel}
            />
          ) : ''}
        </div>
      </React.Fragment>
    )
  }
}

export default HandlingCMS